export default __webpack_public_path__ + "static/tiaser2018-6010049b1b4ec7c7f0938f92663bf2e2.jpg";